import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'app-modal-ajuste-realizado-lg',
	templateUrl: './modal-ajuste-realizado-lg.component.html',
	styleUrls: ['./modal-ajuste-realizado-lg.component.styl'],
})
export class ModalAjusteRealizadoLgComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: number,
		public dialogRef: MatDialogRef<ModalAjusteRealizadoLgComponent>
	) {}

	public onClose(): void {
		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limite-global/components/modal-ajuste-realizado-lg/modal-ajuste-realizado-lg.component.ts